import { Action } from 'redux-actions';
import { all, put, takeEvery } from 'redux-saga/effects';

import {
  logCritical,
  logError,
} from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getProductFullInformationsRequest } from '../../api/Owner/getProductFullInformations';

import * as ActionTypes from './actionTypes';
import { GetProductFullInfoWorkerPayload } from './types';

function* getProductFullInfoWorker({
  payload,
}: {
  payload: GetProductFullInfoWorkerPayload;
}): Generator {
  const { ownerId, productId } = payload;

  if (!ownerId || !productId) {
    logError(`getProductFullInfoWorker with invalid payload`, {
      ownerId,
      productId,
    });

    yield put(ActionTypes.GET_PRODUCT_FULL_INFO.end({ ownerId, productId }));

    return;
  }

  yield executeSagaRequest(
    ActionTypes.GET_PRODUCT_FULL_INFO,
    getProductFullInformationsRequest({ ownerId, productId }),
    {
      productId,
    },
  );

  yield put(ActionTypes.GET_PRODUCT_FULL_INFO.end({ ownerId, productId }));
}
function* getProductFullInfoWatcher() {
  yield takeEvery<Action<GetProductFullInfoWorkerPayload>>(
    ActionTypes.GET_PRODUCT_FULL_INFO.BASE,
    getProductFullInfoWorker,
  );
}

export default function* ownerSaga() {
  try {
    yield all([getProductFullInfoWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
